import { Formik } from 'formik';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, Label } from 'reactstrap';
import Backend from '../../../../../Layouts/Backend';
import { Alert, Button, Dropdown, Input } from '../../../../../UI/Common';
import DatePicker from 'react-datepicker';
import Required from '../../../../../UI/Required';
import validationSchema from '../validation';
import Datagrid from '../../../../../UI/Datagrid';

function NewProcessPage({ t, batchReport, ...props }) {
  const columns = [{ dataField: 'name', text: 'Group', sort: true }];
  const defaultSorted = [{ dataField: 'name', order: 'asc' }];
  const [groupIds, setGroupIds] = React.useState([]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setGroupIds([...groupIds, row.id]);
    } else {
      setGroupIds(groupIds.filter((x) => x !== row.id));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    if (isSelect) {
      setGroupIds(ids);
    } else {
      setGroupIds([]);
    }
  };
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: groupIds,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  const form = {
    process: '',
    beginTime: new Date(),
    endTime: new Date(),
    additional: '',
    filler: null,
  };
  let timeFormat = 'HH:mm';
  if (props.i18n.language === 'en_US') {
    timeFormat = 'h:mm aa';
  }
  if (props.getBatchReportError) {
    return (
      <Backend>
        <div className="content-inner">{props.getBatchReportError}</div>
      </Backend>
    );
  }
  return (
    <Backend title={`New Process for: ${batchReport.batchNumber}`}>
      <div className="content-inner">
        <Formik
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => props.onCreateProcess({ ...values, groupIds })}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldValue,
            setFieldTouched,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form className="w-50">
                <Input
                  required
                  id="process"
                  label="Process Name"
                  onChange={handleChange('process')}
                  value={values.process}
                  invalid={touched.process}
                  error={errors.process}
                />
                <div>
                  <FormGroup className="d-inline-block mr-2">
                    <Label htmlFor="beginTime">
                      {t('Beginning')} <Required />
                    </Label>
                    <DatePicker
                      id="beginTime"
                      autoComplete="off"
                      className="form-control"
                      selected={values.beginTime}
                      onChange={(date) => setFieldValue('beginTime', date)}
                      showTimeSelect
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat={`MM/dd/yyyy ${timeFormat}`}
                    />
                  </FormGroup>
                  <FormGroup className="d-inline-block">
                    <Label htmlFor="endTime">
                      {t('Ending')} <Required />
                    </Label>
                    <DatePicker
                      id="endTime"
                      autoComplete="off"
                      className="form-control"
                      selected={values.endTime}
                      onChange={(date) => setFieldValue('endTime', date)}
                      showTimeSelect
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat={`MM/dd/yyyy ${timeFormat}`}
                    />
                  </FormGroup>
                </div>
                {batchReport.containsNames ? (
                  <Dropdown
                    id="filler"
                    label="Filler"
                    data={props.users || []}
                    onChange={({ value, text }) => {
                      setFieldValue('filler', value);
                      setFieldValue('additional', text);
                    }}
                    value={values.filler}
                    valueKey="id"
                    nameKey="userName"
                    invalid={touched.filler}
                    error={errors.filler}
                  />
                ) : (
                  <Input
                    id="additional"
                    label={batchReport.additionalField}
                    onChange={handleChange('additional')}
                    value={values.additional}
                    invalid={touched.additional}
                    error={errors.additional}
                  />
                )}
                <Datagrid
                  datagridProps={{
                    keyField: 'id',
                    data: props.groups,
                    loading: props.fetchingGroups,
                    defaultSorted,
                    columns,
                    selectRow,
                  }}
                  noSearch
                  noPagination
                  noExport
                />
                <Alert.Error text={props.errors} />
                <Button
                  id="create-process-btn"
                  loading={props.isSubmitting}
                  onClick={handleSubmit}
                >
                  <i className="md-icon">done</i>
                  {t('Create')}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
}

export default withTranslation('app')(NewProcessPage);
